import { apiService } from './apiService';
import {
  OrgAdminAssignmentDto,
  OrgAdminsListDto,
} from 'types/api.types';

const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};

export const getOrgAdminAssignments = async (): Promise<OrgAdminsListDto | null> => {
  try {
    return await apiService.get<OrgAdminsListDto>('/admin/org-admins');
  } catch (error) {
    console.error('Failed to load org admin assignments:', error);
    return null;
  }
};

export const assignOrgAdmin = async (
  adminEmail: string,
  orgId: number,
): Promise<OrgAdminAssignmentDto | null> => {
  try {
    return await apiService.post<OrgAdminAssignmentDto>('/admin/org-admins', {
      adminEmail,
      orgId,
    });
  } catch (error) {
    console.error('Failed to assign org admin:', error);
    return null;
  }
};

export const updateOrgAdminAssignment = async (
  adminEmail: string,
  orgId: number,
  isActive: boolean,
): Promise<OrgAdminAssignmentDto | null> => {
  try {
    return await apiService.patch<OrgAdminAssignmentDto>('/admin/org-admins', {
      adminEmail,
      orgId,
      isActive,
    });
  } catch (error) {
    console.error('Failed to update org admin assignment:', error);
    return null;
  }
};

export interface RemoveOrgAdminResult {
  success: boolean;
  errorMessage?: string;
}

export const removeOrgAdminAssignment = async (
  adminEmail: string,
  orgId: number,
): Promise<RemoveOrgAdminResult> => {
  try {
    await apiService.delete<void>(
      `/admin/org-admins?adminEmail=${encodeURIComponent(adminEmail)}&orgId=${orgId}`,
    );
    return { success: true };
  } catch (error) {
    console.error('Failed to remove org admin assignment:', error);
    return {
      success: false,
      errorMessage: getErrorMessage(error, 'Unable to remove org admin assignment.'),
    };
  }
};
